var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.prompt()}}},[_vm._t("default",function(){return [_c('button',{staticClass:"delete",attrs:{"type":"button"}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }